var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-navigation-drawer",
    {
      staticClass: "rounded-0",
      attrs: {
        width: 240,
        permanent: !_vm.$vuetify.breakpoint.sm && !_vm.$vuetify.breakpoint.xs,
        dark: "",
        app: "",
        "mini-variant": _vm.$store.state.sidebar.mini,
        "expand-on-hover":
          !_vm.$vuetify.breakpoint.sm &&
          !_vm.$vuetify.breakpoint.xs &&
          _vm.$store.state.sidebar.expand_on_hover &&
          !_vm.settings_menu,
      },
      on: {
        "update:miniVariant": function ($event) {
          return _vm.$set(_vm.$store.state.sidebar, "mini", $event)
        },
        "update:mini-variant": function ($event) {
          return _vm.$set(_vm.$store.state.sidebar, "mini", $event)
        },
      },
      model: {
        value: _vm.$store.state.sidebar.open,
        callback: function ($$v) {
          _vm.$set(_vm.$store.state.sidebar, "open", $$v)
        },
        expression: "$store.state.sidebar.open",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "sidebar-card",
          attrs: { width: "240", color: "#28536B" },
          on: {
            mouseenter: function ($event) {
              return _vm.handleExpandMenu(true)
            },
            mouseleave: function ($event) {
              return _vm.handleExpandMenu(false)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "v-list",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.$store.state.sidebar.mini,
                      expression: "!$store.state.sidebar.mini",
                    },
                  ],
                  staticStyle: { height: "100px" },
                },
                [
                  _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        {
                          staticClass: "pt-1",
                          staticStyle: {
                            display: "flex",
                            "justify-content": "center",
                          },
                        },
                        [
                          _c("v-img", {
                            staticClass: "pt-0",
                            staticStyle: {
                              "max-width": "100%",
                              "margin-top": "14px",
                            },
                            attrs: {
                              transition: "fade-transition",
                              src: require("@/assets/images/syscore_logo.svg"),
                              contain: "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.$store.state.sidebar.mini,
                      expression: "$store.state.sidebar.mini",
                    },
                  ],
                  staticClass: "pt-3",
                  staticStyle: { height: "100px" },
                },
                [
                  _c("v-img", {
                    staticClass: "pt-8",
                    staticStyle: { margin: "0 auto" },
                    attrs: {
                      transition: "fade-transition",
                      src: require("@/assets/images/syscore_logo_mini.svg"),
                      contain: "",
                      height: "80",
                      width: "80%",
                    },
                  }),
                ],
                1
              ),
              _c("v-divider", { staticClass: "mt-0" }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sidebar-nav" },
            _vm._l(_vm.items, function (item) {
              return _c(
                "div",
                {
                  key: item.title,
                  staticStyle: { "scroll-margin-top": "100px" },
                },
                [
                  item.visible
                    ? _c(
                        "v-list",
                        { attrs: { dense: "", nav: "" } },
                        [
                          item.visible &&
                          "items" in item &&
                          item.items.length > 0
                            ? _c(
                                "v-list-group",
                                {
                                  key: item.title,
                                  class: {
                                    "sidebar-group--current":
                                      _vm.isCurrentGroup(item),
                                  },
                                  attrs: { "no-action": "" },
                                  model: {
                                    value: item.active,
                                    callback: function ($$v) {
                                      _vm.$set(item, "active", $$v)
                                    },
                                    expression: "item.active",
                                  },
                                },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      attrs: { slot: "activator" },
                                      slot: "activator",
                                    },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: item.icon },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c(
                                            "v-list-item-title",
                                            { staticClass: "item-title" },
                                            [_vm._v(_vm._s(item.title))]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._l(item.items, function (subItem) {
                                    return _c(
                                      "router-link",
                                      {
                                        key: subItem.title,
                                        attrs: { to: "/" + subItem.path },
                                      },
                                      [
                                        subItem.visible
                                          ? _c(
                                              "v-list-item",
                                              {
                                                staticClass: "subitem",
                                                attrs: { ripple: "" },
                                                on: { click: _vm.close },
                                              },
                                              [
                                                _c(
                                                  "v-list-item-content",
                                                  { staticClass: "pl-6" },
                                                  [
                                                    _c("v-list-item-title", [
                                                      _vm._v(
                                                        _vm._s(subItem.title)
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              )
                            : item.visible
                            ? _c(
                                "router-link",
                                { attrs: { to: "/" + item.path } },
                                [
                                  _c(
                                    "v-list-item",
                                    { key: item.title, attrs: { link: "" } },
                                    [
                                      _c(
                                        "v-list-item-icon",
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: item.icon },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-list-item-content",
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v(_vm._s(item.title)),
                                          ]),
                                        ],
                                        1
                                      ),
                                      item.path == _vm.my_payslips &&
                                      _vm.$store.state.my_payslips_pending > 0
                                        ? _c(
                                            "v-list-item-action",
                                            { staticClass: "my-0" },
                                            [
                                              _c(
                                                "v-chip",
                                                {
                                                  attrs: {
                                                    "x-small": "",
                                                    color: "orange",
                                                    dark: "",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$store.state
                                                        .my_payslips_pending
                                                    )
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            }),
            0
          ),
          _c("div", { staticClass: "sidebar-user" }, [
            _c("div", { staticClass: "sidebar-user__avatar" }, [
              _vm._v(_vm._s(_vm.getInitials())),
            ]),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.$store.state.sidebar.mini,
                    expression: "!$store.state.sidebar.mini",
                  },
                ],
                staticClass: "sidebar-user__info",
              },
              [
                _c("div", { staticClass: "sidebar-user__name" }, [
                  _vm._v(_vm._s(_vm.getName())),
                ]),
                _c("div", { staticClass: "sidebar-user__email" }, [
                  _vm._v(_vm._s(_vm.getEmail())),
                ]),
              ]
            ),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.$store.state.sidebar.mini,
                    expression: "!$store.state.sidebar.mini",
                  },
                ],
                staticClass: "sidebar-user__actions",
              },
              [
                _c(
                  "v-menu",
                  {
                    attrs: {
                      top: "",
                      "offset-y": "",
                      light: "",
                      "close-on-content-click": false,
                      "max-width": "300",
                      eager: "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-btn",
                              _vm._g(
                                _vm._b(
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      title: "Configuración",
                                      "aria-label": "Configuración",
                                    },
                                  },
                                  "v-btn",
                                  attrs,
                                  false
                                ),
                                on
                              ),
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-cog"),
                                ]),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                    model: {
                      value: _vm.settings_menu,
                      callback: function ($$v) {
                        _vm.settings_menu = $$v
                      },
                      expression: "settings_menu",
                    },
                  },
                  [
                    _c(
                      "v-list",
                      { attrs: { dense: "" } },
                      [
                        _c("PushNotificationsItem", { attrs: { dense: "" } }),
                        _c(
                          "v-list-item",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.$router.push("/change-password")
                              },
                            },
                          },
                          [
                            _c(
                              "v-list-item-icon",
                              { staticClass: "mr-3" },
                              [
                                _c("v-icon", { attrs: { small: "" } }, [
                                  _vm._v("mdi-lock-reset"),
                                ]),
                              ],
                              1
                            ),
                            _c(
                              "v-list-item-content",
                              [
                                _c("v-list-item-title", [
                                  _vm._v("Cambiar contraseña"),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-btn",
                  {
                    attrs: {
                      icon: "",
                      small: "",
                      title: "Cerrar sesión",
                      "aria-label": "Cerrar sesión",
                    },
                    on: {
                      click: function ($event) {
                        _vm.dialog_logout = true
                      },
                    },
                  },
                  [
                    _c("v-icon", { attrs: { small: "" } }, [
                      _vm._v("mdi-export"),
                    ]),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _c("DialogYesNo", {
        attrs: {
          open: _vm.dialog_logout,
          title: "Confirmar",
          message: "¿Estas seguro que quieres cerrar sesion?",
        },
        on: {
          cancel: function ($event) {
            _vm.dialog_logout = false
          },
          accept: _vm.logoutConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }